export default {
  top: '/session_application',
  conf: (id) => {
    return `/session_application/conf/${id}`;
  },
};
